import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

/**
 * The address, industry-code and (for customers) cash-on-delivery fields shared by the customer and vendor forms.
 * Renders as cells of the form's 2-column grid. Customers store the postal code as `zip_code`, vendors as `postal_code`.
 */
const PartyFields = ({ formData, setFormData, postalField = 'postal_code', cod = false }) => {
  const set = (field) => (e) => setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  return (
    <>
      <div className="col-span-2 space-y-2">
        <Label>Address</Label>
        <Input placeholder="Street address" value={formData.address || ''} onChange={set('address')} data-testid="party-address" />
        <Input placeholder="Address line 2 (optional)" value={formData.address2 || ''} onChange={set('address2')} data-testid="party-address2" />
      </div>
      <div className="space-y-2">
        <Label>City</Label>
        <Input value={formData.city || ''} onChange={set('city')} data-testid="party-city" />
      </div>
      <div className="space-y-2">
        <Label>State / Province / Region</Label>
        <Input value={formData.state || ''} onChange={set('state')} data-testid="party-state" />
      </div>
      <div className="space-y-2">
        <Label>Postal code</Label>
        <Input value={formData[postalField] || ''} onChange={set(postalField)} data-testid="party-postal" />
      </div>
      <div className="space-y-2">
        <Label>Country</Label>
        <Input placeholder="Defaults to the company's country" value={formData.country || ''} onChange={set('country')} data-testid="party-country" />
      </div>
      <div className="space-y-2">
        <Label>Industry code</Label>
        <Input value={formData.industry_code || ''} onChange={set('industry_code')} data-testid="party-industry" />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="space-y-2">
          <Label>NAICS</Label>
          <Input inputMode="numeric" placeholder="2 to 6 digits" value={formData.naics || ''} onChange={set('naics')} data-testid="party-naics" />
        </div>
        <div className="space-y-2">
          <Label>SIC</Label>
          <Input inputMode="numeric" placeholder="2 to 4 digits" value={formData.sic || ''} onChange={set('sic')} data-testid="party-sic" />
        </div>
      </div>
      {cod && (
        <label className="col-span-2 flex items-center gap-2 text-sm">
          <input type="checkbox" checked={!!formData.is_cod} onChange={(e) => setFormData((prev) => ({ ...prev, is_cod: e.target.checked }))} data-testid="party-cod" />
          <span>Cash on delivery (COD): payment is due when the goods are delivered</span>
        </label>
      )}
    </>
  );
};

export default PartyFields;
